import $ from 'jquery';

class GallerySlider {
  constructor() {
    this.gallery = $('.js-gallery');
    this.thumbnails = $('.js-gallery-thumbnails');

    this.galleryLoaded = false;

    this.galleryInit();
  }

  galleryInit() {
    if (!this.gallery.length) {
      return;
    }

    this.thumbnails.flexslider({
      animation: 'slide',
      controlNav: false,
      startAt: 0,
      customDirectionNav: $('.js-gallery-thumbnails-nav a'),
      touch: true,
      animationLoop: false,
      slideshow: false,
      itemWidth: 85,
      itemMargin: 5,
      asNavFor: '#gallery',
    });

    this.gallery.flexslider({
      animation: 'slide',
      controlNav: false,
      directionNav: !this.gallery.hasClass('is-noslider'),
      startAt: 0,
      animationLoop: false,
      customDirectionNav: $('.js-gallery_nav a'),
      touch: true,
      sync: 'gallery-thumbnails',
      smoothHeight: true,
    });
  }
}

export default GallerySlider;



// WEBPACK FOOTER //
// ./src/scripts/modules/gallery-slider.js